import { FeedFormat } from "js/crossword/types";

function getDate(): string {
  const today = new Date();
  const formatNumber = (n) => n.toLocaleString('en-US', { minimumIntegerDigits: 2 });
  return [
    today.getFullYear(),
    formatNumber(today.getMonth() + 1),
    formatNumber(today.getDate()),
  ].join("-");
}

const configOverrideMap = {
  [FeedFormat.GERMAN_ARROW_WORD]: {
    feedSlug: "arrowword-german-test",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/arrowword-german-test/6a8d70b4-d1dd-42a8-83fb-65cbfbc14742.json",
    copyright: null,
  },
  [FeedFormat.CN2I_HANNEQUART]: {
    feedSlug: "cn2i_la-grille-du-dimanche-cn2i",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/cn2i_la-grille-du-dimanche-cn2i/9344ff43-9d76-4088-a98a-2a0dc1688513.json",
    copyright: null,
  },
  [FeedFormat.HEARST]: {
    feedSlug: "hearst_premier-sunday-crossword",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/hearst_premier-sunday-crossword/69e466de-4f6e-4ae8-969a-2b833c0f7329.json",
    copyright: null
  },
  [FeedFormat.HEARST_EUGENE_SHEFFER]: {
    feedSlug: "hearst_eugene-sheffer-crossword",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/hearst_eugene-sheffer-crossword/a126be90-d2b3-4027-8020-0af591812d6b.json",
    copyright: null,
  },
  [FeedFormat.HEARST_MICRO]: {
    feedSlug: "hearst_micro-crossword",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/hearst_micro-crossword/3eec918f-5db4-4020-895a-337caa798597.json",
    copyright: null
  },
  [FeedFormat.LAROUSSE]: {
    feedSlug: "larousse_mots-croises-larousse",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/larousse_mots-croises-larousse/7a418fe2-99ee-4bd1-a8e7-7cb1e4b0ab58.json",
    copyright: "Fourni par SOFTGAMES / Contenu par © RCI-Jeux pour Larousse",
  },
  [FeedFormat.REACH]: {
    feedSlug: "express_quick-crossword",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/express_quick-crossword/9bfc9db3-6320-4083-ab89-abeb3f6115d1.json",
    copyright: null,
  }, 
  [FeedFormat.REACH_BAUER]: {
    feedSlug: "mirror_classic-crossword",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/mirror_classic-crossword/6f922cea-d3a3-47d6-9dae-9c76c7b19f2a.json",
    copyright: null,
  }, 
  [FeedFormat.TCA]: {
    feedSlug: "tca_la-times-daily-crossword",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/tca_la-times-daily-crossword/27e10a1d-4977-4236-b9c1-e56cfb10cfb1.json",
    copyright: "© 2020 Tribune Content Agency, LLC",
  },
  [FeedFormat.TCA_MINI]: {
    feedSlug: "tca_mini-crossword",
    metaDataServiceBaseUrl: "https://crosswords-sgweb.gamedistribution.com",
    startingDateFeedUrl: "https://crosswords-sgweb.gamedistribution.com/storage/tca_mini-crossword/5a6188e9-e881-4e11-9d66-d029eaf16ec9.json",
    copyright: null,
  },
}

export function getConfigOverride(format: FeedFormat) {
  const {
    feedSlug,
    metaDataServiceBaseUrl,
    startingDateFeedUrl,
    copyright,
  } = configOverrideMap[format];

  return {
        feedSlug,
        metaDataServiceBaseUrl,
        startingDateFeedUrl,
        startingDate: getDate(),
        customisation: {
          copyright,
          mainUIColor: null,
          selectedSquareHighlightColor: null,
          buttonBackgroundColor: null,
          buttonTextColor: null,
          fontUrl: null,
          fontFamily: null,
          scrollBarBackgroundColor: null,
          secondClueColor: null,
          cellRevealedFontColor: null,
          cellCorrectFontColor: null,
          scrollBarHeadColor: null,
          disablePrint: false,
          disableCalendar: false,
          disableHelp: false,
          disableTimer: false,
          disableAutocheck: false,
          useGISNameOnWelcomeScreen: false,
        }
  };
}
